import { GoogleLogin } from "@react-oauth/google";
import { config } from "./Components/Config";
import { format } from "date-fns";
import { jwtFetch } from "./utils/apiClient";

const Login = () => {
  const handleLoginSuccess = async (credentialResponse) => {
    try {
      if (!credentialResponse.credential) {
        alert('Google authentication failed. No credential received.');
        return;
      }

      await checkUser(credentialResponse.credential);

    } catch (error) {
      console.error('[Login] handleLoginSuccess error:', error);
      alert('Login failed: ' + error.message);
    }
  };

  const handleLoginError = () => {
    console.error('[Login] Google login failed');
    alert('Google authentication failed. Please try again.');
  };

  const checkUser = async (idToken) => {
    try {
      const requestUser = {
        id_token: idToken
      };

      const fetchUser = await jwtFetch(config.ENDPOINT + 'login', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestUser)
      });

      const responseUser = await fetchUser.json();

      if ((responseUser.status === 200) && responseUser.data) {
        const userData = responseUser.data;

        const dataUser = {
          "google_id": userData.google_id,
          "google_user_fullname": userData.google_user_fullname || userData.full_name,
          "google_user_picture": userData.google_user_picture || userData.profile_picture,
          "user_keyid": userData.user_keyid,
          "full_name": userData.full_name,
          "email_address": userData.email_address,
          "user_level": userData.user_level,
          "user_department": userData.user_department,
          "user_position": userData.user_position,
          "user_role_division": userData.user_role_division,
          "profile_picture": userData.profile_picture,
          "last_login": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
          "token": userData.token,
          "token_expires_at": userData.token_expires_at
        }

        await editUser(dataUser);
        localStorage.setItem('crmUser', JSON.stringify(dataUser));
        localStorage.setItem('jwtToken', userData.token);

        if (userData.user_department === 'Sales') {
          window.location.href = '/invoicerequest';
        } else {
          window.location.href = '/dashboard';
        }
      } else {
        console.error('[Login] Login failed:', responseUser);
        alert(responseUser.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      console.error('[Login] checkUser error:', error);
      alert('Login failed: ' + error.message);
    }
  };

  const editUser = async (dataUser) => {
    try {
      await jwtFetch(config.ENDPOINT + 'update/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataUser)
      });
    } catch (error) {
      console.error('Error in editUser:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  return (
    <div id="login">
      <div className="d-flex flex-column align-items-center justify-content-center vh-100">
        <img className="mb-5" src="/pointstar.png" alt="PointStar" width={350}/>
        <GoogleLogin
          onSuccess={handleLoginSuccess}
          onError={handleLoginError}
        />
      </div>
    </div>
  );
};

export default Login;
